/* SOLBELI — Punto de entrada único a EasySell (Dawn). Código propio, se carga una sola vez (global).
   Por qué existe: EasySell enlaza su disparador documentado (clase `es-popup-button-overwrite`) sobre los
   elementos presentes en la página. El carrito lateral y la página de carrito se vuelven a pintar tras cada
   alta, cambio de cantidad o eliminación; un botón nuevo ya no está enlazado y deja de responder.
   Solución sin APIs inventadas:
   - Un único elemento "proxy" estable (fuera de cualquier zona que se vuelva a pintar) lleva la clase
     documentada de EasySell y existe desde el HTML inicial, igual que cualquier botón de EasySell.
   - Los botones de compra dinámicos (cajón y /cart) NO llevan esa clase: llevan data-solbeli-easysell-entry
     y, con un único listener delegado en document, activan ese proxy con un clic normal del DOM.
   - Bloquea solo el envío al checkout nativo de Shopify (botón/entrada name="checkout"). */
(() => {
  if (window.__solbeliEasySellEntry) return;
  window.__solbeliEasySellEntry = true;

  const ENTRY = '[data-solbeli-easysell-entry]';
  const PROXY = '[data-solbeli-easysell-proxy]';
  let lastOpen = 0;

  function ensureProxy() {
    let proxy = document.querySelector(PROXY);
    if (proxy || !document.body) return proxy;
    /* Respaldo si el snippet no se renderizó: igualmente estable (cuelga de body). */
    proxy = document.createElement('button');
    proxy.type = 'button';
    proxy.className = 'es-popup-button-overwrite solbeli-easysell-proxy';
    proxy.setAttribute('data-solbeli-easysell-proxy', '');
    proxy.setAttribute('aria-hidden', 'true');
    proxy.tabIndex = -1;
    document.body.appendChild(proxy);
    return proxy;
  }

  const isBlocked = (el) =>
    el.disabled ||
    el.getAttribute('aria-disabled') === 'true' ||
    !!el.closest('cart-drawer.is-empty, cart-drawer-items.is-empty, #main-cart-footer.is-empty');

  function open() {
    const now = Date.now();
    if (now - lastOpen < 500) return;   /* evita doble apertura por doble clic */
    const proxy = ensureProxy();
    if (!proxy) return;
    lastOpen = now;
    proxy.click();
  }
  window.SolbeliEasySell = { open };

  /* Entrada delegada: sobrevive a cualquier reemplazo del HTML del carrito. */
  document.addEventListener('click', (event) => {
    const target = event.target && event.target.closest ? event.target.closest(ENTRY) : null;
    if (!target) return;
    event.preventDefault();
    if (isBlocked(target)) return;
    open();
  }, true);

  /* Cierre del cajón por el fondo: el listener nativo se pierde cuando se reemplaza su HTML. */
  document.addEventListener('click', (event) => {
    const overlay = event.target && event.target.closest ? event.target.closest('#CartDrawer-Overlay') : null;
    const drawer = overlay && overlay.closest('cart-drawer');
    if (drawer && drawer.classList.contains('active') && typeof drawer.close === 'function') drawer.close();
  });

  /* Único bloqueo: el envío al checkout nativo (Enter, apps externas). No afecta a add/update/change. */
  const isNativeCheckout = (el) => !!el && el.matches && el.matches('button[name="checkout"], input[name="checkout"]');
  document.addEventListener('click', (event) => {
    const t = event.target && event.target.closest ? event.target.closest('button[name="checkout"], input[name="checkout"]') : null;
    if (t) event.preventDefault();
  }, true);
  document.addEventListener('submit', (event) => {
    if (isNativeCheckout(event.submitter)) event.preventDefault();
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensureProxy, { once: true });
  else ensureProxy();
})();
